module.exports = __webpack_public_path__ + "img/photo-15.12247cc4.webp";